import { useOfflineSync } from '../hooks/useOfflineSync'
import styles from './OfflineIndicator.module.css'

export default function OfflineIndicator() {
  const { isOnline, queueSize, isSyncing, syncNow } = useOfflineSync()

  // Don't show anything if online and queue is empty
  if (isOnline && queueSize === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      {!isOnline ? (
        <div className={`${styles.indicator} ${styles.offline}`}>
          <OfflineIcon />
          <span className={styles.text}>Offline Mode</span>
          {queueSize > 0 && (
            <span className={styles.badge}>{queueSize}</span>
          )}
        </div>
      ) : queueSize > 0 ? (
        <div className={`${styles.indicator} ${styles.syncing}`}>
          {isSyncing ? (
            <>
              <SyncIcon className={styles.spinning} />
              <span className={styles.text}>Syncing...</span>
            </>
          ) : (
            <>
              <SyncIcon />
              <span className={styles.text}>{queueSize} changes pending</span>
              <button
                className={styles.syncButton}
                onClick={syncNow}
                disabled={isSyncing}
              >
                Sync Now
              </button>
            </>
          )}
        </div>
      ) : null}
    </div>
  )
}

function OfflineIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M1 1l22 22M16.72 11.06A10.94 10.94 0 0119 12.55M5 12.55a10.94 10.94 0 015.17-2.39M10.71 5.05A16 16 0 0122.58 9M1.42 9a15.91 15.91 0 014.7-2.88M8.53 16.11a6 6 0 016.95 0M12 20h.01" />
    </svg>
  )
}

function SyncIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      className={className}
    >
      <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0118.8-4.3M22 12.5a10 10 0 01-18.8 4.2" />
    </svg>
  )
}
